import { render } from "./RatingsListCoord.vue?vue&type=template&id=35a8dc74&scoped=true"
import script from "./RatingsListCoord.vue?vue&type=script&lang=js"
export * from "./RatingsListCoord.vue?vue&type=script&lang=js"

import "./RatingsListCoord.vue?vue&type=style&index=0&id=35a8dc74&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a8dc74"]])

export default __exports__